import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

const storageKey = 'password';

@Injectable({
  providedIn: 'root'
})
export class PasswordStorageService {

  passwordEvent: BehaviorSubject<string> = new BehaviorSubject<string>(window.sessionStorage.getItem(storageKey));

  constructor() {

  }

  storePassword(password: string) {
    if (!password) {
      window.sessionStorage.removeItem(storageKey);
    } else {
      window.sessionStorage.setItem(storageKey, password);
    }
    this.passwordEvent.next(password);
  }
}
